import React from "react";
import { SingleJobsScheduledHoursListType } from "../../../redux/scheduling/schedulingTypes";
import CustomizedAvatar from "../../commons/CircularAvatar/CustomizedAvatar";
import JobSummaryDetails from "./JobSummaryDetails";
import { TableHeader, TableLoader } from "../../commons";
import BoxLoader from "../../commons/BoxLoader/BoxLoader";
import { USER_WORKING_ON_PARTICULAR_JOBS_HEADERS } from "../../../constant/tableHeadersConstants/thingsToDo/JobClosureModuleConst";
import JobWorkingUsersTableData from "./JobWorkingUsersTableData";
type AppProps = {
  data: SingleJobsScheduledHoursListType[] | [];
  fetching: boolean;
  totalHours: number | string;
  setParticulerjobsUsersList: React.Dispatch<
    React.SetStateAction<SingleJobsScheduledHoursListType[] | []>
  >;
  setButtonDisable: React.Dispatch<React.SetStateAction<boolean>>;
};
const JobWorkingUsersTable = ({
  data,
  fetching,
  totalHours,
  setButtonDisable,
  setParticulerjobsUsersList,
}: AppProps) => {
  return (
    <>
      <div className="jobsType">
        <table className="table">
          <thead
            className="text-left sticky-table-header"
            style={{
              backgroundColor: "#f4f6f8",
              color: "#464f60",
              fontSize: "12px",
              fontWeight: "600",
            }}
          >
            <tr
              style={{
                color: "#464f60",
                backgroundColor: "#e8ecf0",
              }}
            >
              <td>
                <span
                  style={{
                    fontSize: "12px",
                    fontWeight: "600",
                    color: "#464f60",
                  }}
                >
                  TOTAL
                </span>
              </td>

              <td
                colSpan={2}
                className="text-end"
                style={{
                  fontSize: "12px",
                  fontWeight: "600",
                  color: "#464f60",
                }}
              >
                {totalHours ? totalHours : 0}
              </td>
            </tr>
            <TableHeader
              tableHeader={USER_WORKING_ON_PARTICULAR_JOBS_HEADERS}
            />
          </thead>
          <tbody>
            {fetching ? (
              <div>
                <BoxLoader />
              </div>
            ) : data?.length > 0 ? (
              <JobWorkingUsersTableData
                data={data}
                setButtonDisable={setButtonDisable}
                tableHeader={USER_WORKING_ON_PARTICULAR_JOBS_HEADERS}
                setParticulerjobsUsersList={setParticulerjobsUsersList}
              />
            ) : (
              <tr className="col-md-12" style={{ width: "100%" }}>
                {" "}
                <td
                  colSpan={3}
                  className="p-5"
                  style={{
                    textAlign: "center",
                    height: "100%", // adjust as needed for vertical centering
                    verticalAlign: "middle",
                  }}
                >
                  <span>No Data Found</span>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default JobWorkingUsersTable;
